<template>
  <section id="home" class="hero">

    <div class="bg-elements">

      <div class="bg-circle circle-1"></div>

      <div class="bg-circle circle-2"></div>

      <div class="bg-circle circle-3"></div>

    </div>

    <div class="hero-content">

      <h1 class="hero-title animate-slide-in delay-100">

        <span class="gradient-text">
          BLACK
        </span>

        <span>
          PALADINS
        </span>

      </h1>

      <p class="hero-subtitle animate-slide-in delay-200">
        {{ heroLocale.subtitle }}
      </p>

      <p class="hero-description animate-slide-in delay-300" v-html="heroLocale.description">
      </p>

      <div class="hero-buttons animate-slide-in delay-400">

        <RouterLink to="/#projects" class="btn-primary">
          {{ heroLocale.projects}}
        </RouterLink>

        <RouterLink to="/#contact" class="btn-outline animate-pulse-border">
           {{ heroLocale.contact }}
        </RouterLink>

      </div>

      <RouterLink
            to="#featured-project">

        <div class="scroll-indicator">

        
          <img
            :src="setaPraBaixo"
            :alt="setaPraBaixo"
            class="scroll-icon"
          />

        </div>
      </RouterLink>
    </div>

  </section>
</template>

<script setup>
import setaPraBaixo from "@/assets/icons/setaPraBaixo.png"

import { computed } from "vue"
import { useI18n } from "vue-i18n"
import { hero } from "@/data/hero"

const { locale } = useI18n()

const heroLocale = computed(() => {

  if (locale.value === "pt") {
    return hero.pt
  }

  return hero.en

})
</script>

<style scoped>
.hero {
  margin: 0 auto;
  position: relative;
  height: 850px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: linear-gradient(
    180deg,
    var(--bg-header) 0%,
    var(--bg-primario) 50%,
    var(--bg-secundario) 100%
  );
}

.bg-elements {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
}

.bg-circle {
  position: absolute;
  border-radius: 50%;
  filter: blur(120px);
  opacity: 0.2;
}

.circle-1 {
  width: 250px;
  height: 250px;
  top: 80px;
  left: 60px;
  background: var(--card-destaque);
  animation: float 6s ease-in-out infinite;
}

.circle-2 {
  width: 300px;
  height: 300px;
  bottom: 80px;
  right: 60px;
  background: var(--card-secundaria);
  animation: float 6s ease-in-out infinite;
  animation-delay: -3s;
  opacity: 0.15;
}

.circle-3 {
  width: 350px;
  height: 350px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: var(--card-base);
  opacity: 0.1;
}

.hero-content {
  position: relative;
  z-index: 10;
  padding: 0 20px;
}

.hero-title {
  font-family: "Orbitron", sans-serif;
  font-size: clamp(30px, 6vw, 80px);
}

.hero-subtitle {
  font-family: "Orbitron", sans-serif;
  font-size: 28px;
  margin-bottom: 30px;
  color: var(--card-destaque);
  letter-spacing: 1px;
  text-transform: uppercase;
}

.hero-description {
  font-size: 20px;
  color: var(--cor-texto-secundario);
  max-width: 700px;
  margin: 0 auto 40px;
  letter-spacing: 1px;
}

.hero-buttons {
  margin-top: 80px;
  display: flex;
  gap: 50px;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
}

.btn-primary {
  font-size: 18px;
  padding: 14px 30px;
  border-radius: 12px;
  font-weight: 600;
  text-decoration: none;
  color: var(--cor-texto-principal);
  letter-spacing: 1px;
  background: linear-gradient(
    135deg,
    var(--card-secundaria),
    var(--card-destaque)
  );
  transition: 0.3s;
}

.btn-primary:hover {
  transform: scale(1.05);
}

.btn-outline {
  font-size: 18px;
  padding: 14px 30px;
  border-radius: 12px;
  border: 2px solid var(--card-destaque);
  color: var(--cor-texto-principal);
  font-weight: 600;
  text-decoration: none;
  transition: 0.3s;
  letter-spacing: 1px;
}

.btn-outline:hover {
  transform: scale(1.05);
}

.scroll-indicator {
  margin-top: 100px;
  display: flex;
  justify-content: center;
  opacity: 0.5;
  animation: float 3s infinite;
}

.scroll-icon {
  width: 35px;
  height: 35px;
  object-fit: contain;
}

@media (max-width: 1280px) {

  .hero {
    margin: 60px auto 0 auto;
    height: 100vh;
  }

  .hero-subtitle {
    font-size: 18px;
    margin: 10px 0 20px 0;
  }

  .hero-buttons {
    margin-top: 80px;
  }

  .scroll-indicator {
    margin-top: 80px;
  }

}

@media (max-width: 800px) {

  .hero {
    margin: 20px auto 0 auto;
    height: 100vh;
  }

  .hero-subtitle {
    font-size: 14px;
    margin: 6px 0 20px 0;
  }

  .hero-description {
    font-size: 12px;
    max-width: 350px;
  }

  .hero-buttons {
    margin-top: 60px;
    gap: 20px;
  }

  .btn-primary {
    font-size: 12px;
    padding: 6px 10px;
    border-radius: 10px;
  }

  .btn-outline {
    font-size: 12px;
    padding: 6px 10px;
    border-radius: 10px;
  }

  .scroll-indicator {
    margin-top: 100px;
  }

  .scroll-icon {
    width: 40px;
    height: 40px;
  }

}
</style>